import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { AgendaComponent } from './agenda.component';
import { TareaModule } from '../../forms/tareas/tarea.module';
import { ActividadesModule } from '../actividades/actividades.module';

@NgModule({
  declarations: [
    AgendaComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ActividadesModule,
  ],
  exports: [
    AgendaComponent,
  ]
})
export class AgendaModule { }
